// frontend/src/components/Transaction/TransactionTable.js
import React from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  IconButton,
  Chip,
  Paper,
  Tooltip,
} from "@mui/material";
import { Visibility, Info } from "@mui/icons-material";
import { useTranslation } from "react-i18next";

const TransactionTable = ({
  transactions,
  formatAmount,
  getStatusColor,
  setSelectedTransaction,
}) => {
  const { t } = useTranslation();

  return (
    <TableContainer component={Paper}>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>{t("transactions.columns.date")}</TableCell>
            <TableCell>{t("transactions.columns.type")}</TableCell>
            <TableCell>{t("transactions.columns.amount")}</TableCell>
            <TableCell>{t("transactions.columns.status")}</TableCell>
            {/* <TableCell>{t("transactions.columns.reference")}</TableCell> */}
            <TableCell align="right">{t("common.actions.actions")}</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {transactions.map((transaction) => {
            // Get package name from metadata if available
            // const packageInfo = transaction.metadata?.packageName
            //   ? transaction.metadata.packageName
            //   : transaction.type === "esim_purchase"
            //   ? t("transactions.esimPurchase")
            //   : "";

            return (
              <TableRow key={transaction.id}>
                <TableCell>
                  {new Date(transaction.created_at).toLocaleString()}
                </TableCell>
                <TableCell>
                  {t(`transactions.types.${transaction.type}`, {
                    defaultValue: transaction.type
                      .replace("_", " ")
                      .toUpperCase(),
                  })}
                </TableCell>
                <TableCell>{formatAmount(transaction.amount)}</TableCell>
                <TableCell>
                  <Chip
                    label={t(`status.${transaction.status}`, {
                      defaultValue: transaction.status.toUpperCase(),
                    })}
                    color={getStatusColor(transaction.status)}
                    size="small"
                  />
                </TableCell>

                {/* <TableCell>
                  {transaction.provider_transaction_id ||
                    transaction.id.slice(0, 8)}
                </TableCell> */}
                <TableCell align="right">
                  <Tooltip title={t("common.actions.viewDetails")}>
                    <IconButton
                      size="small"
                      onClick={() => setSelectedTransaction(transaction)}
                    >
                      <Visibility />
                    </IconButton>
                  </Tooltip>

                  {/* {transaction.status === "completed" && (
                    <Tooltip title={t("transactions.downloadReceipt")}>
                      <IconButton
                        size="small"
                        onClick={() => handleDownloadInvoice(transaction.id)}
                      >
                        <GetApp />
                      </IconButton>
                    </Tooltip>
                  )} */}

                  {transaction.type === "esim_purchase" &&
                    transaction.ESIMOrder && (
                      <Tooltip title={t("transactions.viewESIM")}>
                        <IconButton
                          size="small"
                          onClick={() =>
                            (window.location.href = `/orders?id=${transaction.ESIMOrder.id}`)
                          }
                        >
                          <Info />
                        </IconButton>
                      </Tooltip>
                    )}
                </TableCell>
              </TableRow>
            );
          })}
          {transactions.length === 0 && (
            <TableRow>
              <TableCell colSpan={7} align="center">
                {t("transactions.noTransactions")}
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default TransactionTable;
